import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LotsDayChart = ({ data }) => {
  const [series, setSeries] = useState([
    {
      name: "Trades per day",
      type: "line",
      data: [],
    },
    {
      name: "Lots per day",
      type: "line",
      data: [],
    },
  ]);

  const [options, setOptions] = useState({
    responsive: [
      {
        breakpoint: 425,
        options: {
          chart: {
            height: 350,
            width: 300,
          },
        },
      },
      {
        breakpoint: 325,
        options: {
          chart: {
            height: 300,
            width: 250,
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top", // Position legend at the top
      horizontalAlign: "right",
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    colors: ["#39912F", "#8B3231"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    labels: [],
    xaxis: {
      type: "datetime",
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Trades per day",
        title: {
          // text: "Trades per day",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value ?? 0).toFixed(2),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
      {
        opposite: true,
        seriesName: "Lots per day",
        title: {
          // text: "Lots per day",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value ?? 0).toFixed(2),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
  });

  useEffect(() => {
    if (data) {
      const tradesArr = data.trade ? Object.values(data.trade) : [];
      const lotsArr = data.lots ? Object.values(data.lots) : [];
      const dateLabels = data.date ? Object.values(data.date) : [];

      setSeries([
        {
          name: "Trades per day",
          type: "line",
          data: tradesArr,
        },
        {
          name: "Lots per day",
          type: "line",
          data: lotsArr,
        },
      ]);

      setOptions((prevOptions) => ({
        ...prevOptions,
        labels: dateLabels,
        xaxis: {
          categories: dateLabels,
        },
      }));
    }
  }, [data]);

  const hasData = data && (data.trade?.length > 0 || data.lots?.length > 0);

  return (
    <div id="chart">
      {hasData ? (
        <ReactApexChart options={options} series={series} height={250} />
      ) : (
        <div className="no-data">No Data Available</div>
      )}
    </div>
  );
};

export default LotsDayChart;
